export default function SectionLabelWithAccent({
  label = '',
  accentColour = 'transparent',
  className = '',
  style = {},
}) {
  return (
    <div style={{ display: 'flex', gap: '.5rem' }}>
      <div style={{ width: '4px', background: accentColour }} />
      <p style={style} className={className}>
        {label}
      </p>
    </div>
  );
}
